// src/utils/s1UrlParser.js

export const parseSeasonEpisode = (url) => {
  const seasonMatch = url.match(/S(\d+)/i);
  const episodeMatch = url.match(/E(\d+)/i);
  const season = seasonMatch ? `S${seasonMatch[1].padStart(2, '0')}` : null;
  const episode = episodeMatch ? `E${episodeMatch[1].padStart(2, '0')}` : null;
  return { season, episode };
};
